import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Search, X } from "lucide-react";
import SiteSearch from "./SiteSearch";
import { EASE } from "../ui/Reveal";
import { ICON_BUTTON } from "../ui/styles";
import useLang from "../../hooks/useLang";

// Search lives behind an icon and opens as a centered window (also on Ctrl/Cmd + K).
const SearchPalette = () => {
  const { t, dir } = useLang();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setOpen(true);
      } else if (e.key === "Escape") {
        setOpen(false);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} aria-label={t("nav.search")} title={t("nav.search")} className={ICON_BUTTON}>
        <Search size={18} />
      </button>

        {open && (
          <motion.div
            className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm px-4 pt-[14vh]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.25 }}
            onMouseDown={(e) => e.target === e.currentTarget && setOpen(false)}
            dir={dir}
          >
            <motion.div
              role="dialog"
              aria-modal="true"
              aria-label={t("nav.search")}
              className="mx-auto w-full max-w-xl rounded-2xl border border-white/10 bg-ink p-4 shadow-2xl"
              initial={{ opacity: 0, y: -12, scale: 0.98 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 0.3, ease: EASE }}
            >
              <div className="flex items-start gap-3">
                <SiteSearch autoFocus inline className="flex-1" onNavigate={() => setOpen(false)} />
                <button type="button" onClick={() => setOpen(false)} aria-label="Close" className={`${ICON_BUTTON} !h-11 !w-11 flex-shrink-0`}>
                  <X size={18} />
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
    </>
  );
};

export default SearchPalette;
